import { all, put, takeLatest } from "redux-saga/effects";
import { doGet, doPost, doPut } from "../utils/request";
import { getAllDistrictAdminSuccess, getAllDistrictAdminFail, addDistrictAdminSuccess, addDistrictAdminFail, getDistrictAdminDetailsSuccess, getDistrictAdminDetailsFail, updateDistrictAdminSuccess, updateDistrictAdminFail } from "../actionCreators/DistrictAdmin";


function* getAllDistrictAdmin({ obj }) {
  try {
    const response = yield doGet(
      `/districtadmin/getAll?page=${obj?.page}&pageSize=${
        obj?.pageSize
      }&userName=${
        [undefined, null, ""].includes(obj?.searchString)
          ? `""`
          : `"${obj?.searchString}"`
      }&filter=${obj?.filterBody}`
    );
    yield put(getAllDistrictAdminSuccess(response?.data));
  } catch (err) {
    yield put(getAllDistrictAdminFail(err?.response?.data?.message || err?.message));
    yield put(getAllDistrictAdminFail());
  }
}

function* addDistrictAdmin({ obj }) {
  try {
    const response = yield doPost(`/districtadmin/add`, obj);
    yield put(addDistrictAdminSuccess(response?.data));
  } catch (err) {
    // yield put(addETOFail(err?.message));
    yield put(addDistrictAdminFail((err?.response?.data?.message ? err?.response?.data?.message : "Server Down")));
  }
}

function* getDistrictAdminDetails({ obj }) {
  try {
    const response = yield doGet(
      `/districtadmin/getDistrictAdminById/${obj?.userId}`
    );
    yield put(getDistrictAdminDetailsSuccess(response?.data));
  } catch (err) {
    yield put(
      getDistrictAdminDetailsFail(err?.response?.data?.message || err?.message)
    );
    yield put(getDistrictAdminDetailsFail());
  }
}

function* updateDistrictAdmin({ obj }) {
  try {
    const response = yield doPut(`/districtadmin/update`, obj);
    yield put(updateDistrictAdminSuccess(response?.data));
  } catch (err) {
    yield put(updateDistrictAdminFail(err?.response?.data?.message || err?.message));
    yield put(updateDistrictAdminFail());
  }
}

export default function* watcher() {
  yield all([
    takeLatest("GET_ALL_DISTRICT_ADMIN", getAllDistrictAdmin),
    takeLatest("ADD_DISTRICT_ADMIN", addDistrictAdmin),
    takeLatest("GET_DISTRICT_ADMIN_DETAILS", getDistrictAdminDetails),
    takeLatest("UPDATE_DISTRICT_ADMIN", updateDistrictAdmin),
  ]);
}
